<template>
  <div class="mainDiv" :class="movingClass" @mousedown.stop.prevent="moveMain" @wheel.stop.prevent="scroll">
    <span class="el scrollBarElement" :class="movingClass" :style="barStyle" @mousedown.stop.prevent="startDraging" @click.stop.prevent ref="scrollBarElement">&nbsp;</span>
    <span class="scrollBarElement marker" :class="movingClass" v-for="marker in markers || []" :style="{ ...(marker.style || {}), top: `${markerPosition(marker.value)}%` }" :key="marker.value"></span>
  </div>
</template>
<script>
export default {
  props: ['total', 'displayed', 'value', 'markers'],
  data(self) {
    return {
      height: 0,
      localValue: self.value || 0,
      movingClass: null,
    };
  },
  methods: {
    startDraging(evt) {
      const self = this;
      this.movingClass = 'moving';
      this.height = this.$el.getBoundingClientRect().height;

      const bodyPointerEvents = document.body.style.pointerEvents;
      document.body.style.pointerEvents = 'none';
      const mouseMove = (() => {
        let lastMouse = evt;
        return (event) => {
          if (event.buttons < 1) {
            removeEvents(event);
            return;
          }
          const dY = event.clientY - lastMouse.clientY;
          const newValue = this.valueBetweenMinMax(
            this.localValue + dY / ((this.multiplier / 100) * this.height)
          );

          if (this.localValue !== newValue) {
            this.emitChange(newValue);
            this.localValue = newValue;
            lastMouse = event;
          }

          event.stopPropagation();
          event.preventDefault();
        };
      })();

      window.addEventListener('mousemove', mouseMove, false);

      const removeEvents = (event) => {
        window.removeEventListener('mousemove', mouseMove, false);
        window.removeEventListener('mouseup', removeEvents, false);
        event.stopPropagation();
        event.preventDefault();
        self.movingClass = null;
        document.body.style.pointerEvents = bodyPointerEvents;
      };
      window.addEventListener('mouseup', removeEvents, false);
    },
    markerPosition(value) {
      return value * this.multiplier;
    },
    valueBetweenMinMax(val) {
      return Math.min(Math.max(val, 0), this.total - this.displayed);
    },
    moveMain(event) {
      const bnd = this.$refs.scrollBarElement.getBoundingClientRect();
      if (event.clientY > bnd.bottom) {
        this.move(this.displayed);
      } else if (event.clientY < bnd.top) {
        this.move(-this.displayed);
      }
    },
    move(val) {
      const value = this.valueBetweenMinMax(this.localValue + parseFloat(val));
      if (this.localValue !== value) {
        this.emitChange(value);
        this.localValue = value;
      }
    },
    emitChange(newVal) {
      if (this.isValueChanged(this.localValue, newVal)) {
        this.$emit('input', Math.round(newVal));
      }
    },
    isValueChanged(oldVal, newVal) {
      return Math.round(oldVal) !== Math.round(newVal);
    },
    scroll(event) {
      this.move(event.wheelDeltaY < 0 ? 1 : -1);
    }
  },
  computed: {
    barHeight() {
      return (this.displayed / this.total) * 100;
    },
    val() {
      return this.valueBetweenMinMax(this.localValue);
    },
    barStyle() {
      const pos = this.val * this.multiplier;

      return {
        top: pos + '%',
        height: this.barHeight + '%'
      };
    },
    multiplier() {
      const delta = 100 - this.barHeight;
      return delta / (this.total - this.displayed);
    },
  },
  watch: {
    value() {
      if (this.isValueChanged(this.localValue, this.value)) {
        this.localValue = this.value;
      }
    },
    val() {
      if (this.localValue !== this.val) {
        this.emitChange(this.val);
        this.localValue = this.val;
      }
    },
  }
};
</script>

<style scoped>
.mainDiv {
  padding: 0;
  margin: 0;
  width: 19px;
  position: relative;
  cursor: default;

  border-style: solid;
  border-width: 0 2px 0 2px;
  border-color: transparent;
}

.mainDiv:hover,
.mainDiv.moving {
  border-color: #c1c1c1;
  /* background-color: #f1f1f1; */
}

.scrollBarElement {
  position: absolute;
  padding: 0;
  margin: 0 1px 0 1px;
  width: 13px;
  background-color: #c1c1c1;
}

.scrollBarElement:hover {
  background-color: #a8a8a8;
}

.scrollBarElement.moving {
  background-color: #787878;
}

.marker {
  height: 2px;
  background-color: rgb(255, 120, 0); /* #ff9632 */
  width: 13px;
  pointer-events: none;
}
.marker.moving {
  background-color: rgb(255, 136, 0); /* #ff9632 */
}
</style>